import { supabase } from "@/api/supabaseClient";

export type OrganizationSpeciesOption = {
  id: string;
  name: string;
  code?: string;
};

function asRecord(value: unknown): Record<string, unknown> | null {
  if (value == null || typeof value !== "object" || Array.isArray(value)) return null;
  return value as Record<string, unknown>;
}

/** Aktive Arten in der Reihenfolge von list_organization_species. Wissenschaftliche Namen bleiben weg. */
export function organizationSpeciesFromRpc(data: unknown): OrganizationSpeciesOption[] {
  const rows = Array.isArray(data) ? data : [];
  const options: OrganizationSpeciesOption[] = [];
  for (const row of rows) {
    const record = asRecord(row);
    if (!record) continue;
    const id = record.id;
    const name = record.name;
    if (typeof id !== "string" || typeof name !== "string") continue;
    const code = typeof record.code === "string" ? record.code : undefined;
    if (record.is_active === false && code !== "unknown") continue;
    const trimmed = name.trim();
    if (trimmed.length === 0) continue;
    options.push(code ? { id, name: trimmed, code } : { id, name: trimmed });
  }
  return options;
}

/** Nur die Anzeige: code unknown nach hinten. sort_order bleibt auf dem Server. */
export function pinUnknownSpeciesLast<T extends { code?: string }>(options: readonly T[]): T[] {
  const unknown = options.filter((option) => option.code === "unknown");
  if (unknown.length === 0) return [...options];
  return [...options.filter((option) => option.code !== "unknown"), ...unknown];
}

export class OrganizationSpeciesApi {
  static async listActive(organizationId: string): Promise<OrganizationSpeciesOption[]> {
    const { data, error } = await supabase.rpc("list_organization_species", {
      p_organization_id: organizationId,
    });
    if (error) throw error;
    return pinUnknownSpeciesLast(organizationSpeciesFromRpc(data));
  }
}
